import React from 'react';
import Dialog from '@shared/ui/molecules/Dialog';
import './permission-needed-dialog.scss';
import { HeadlineMedium } from '@shared/ui/atoms/fonts/Headline';
import { useDispatch } from "react-redux";
import { closeDialog } from '@shared/store/dialog.duck';
import { BodyRegular } from '@shared/ui/atoms/fonts/Body';
import { PrimaryButton } from '@shared/ui/atoms/buttons/PrimaryButton';
import { BorderlessButton } from '@shared/ui/atoms/buttons/BorderlessButton';
import { ButtonSize } from '@shared/ui/atoms/buttons/ButtonStyling';
import { requestCalendarAccess } from '@shared/auth/authMachine.duck';

export default function PermissionNeededDialog(props: { payload?: any }) {
  const dispatch = useDispatch();
  const permissionType = props.payload?.permissionRequired;

  // @ts-ignore
  const message = script[permissionType]?.message ?? '';

  const close = () => {
    dispatch(closeDialog());
  }

  // MICROSOFT_CALENDAR is a confirm flow, not just an info notice: Continue
  // re-runs the calendar request with interactiveConfirmed so the gateway is
  // allowed to open Microsoft's consent popup/redirect (which may show the
  // "Need admin approval" page in locked-down tenants).
  const confirmMicrosoftConsent = () => {
    dispatch(closeDialog());
    dispatch(requestCalendarAccess({ source: 'manual', interactiveConfirmed: true }) as any);
  }

  return (
    <Dialog isOpen={true} onClose={() => close()}>
      <div className="permissionNeeded">
        <HeadlineMedium className="permissionNeeded__title">Permission needed</HeadlineMedium>
        <div className="permissionNeeded__content">
          <BodyRegular className="permissionNeeded__info" style={{marginBottom: 16}}>{message}</BodyRegular>
        </div>
        {permissionType === 'MICROSOFT_CALENDAR' ? (
          <>
            <PrimaryButton text="button.continue"
                           size={ButtonSize.Large}
                           fullWidth={true}
                           style={{marginBottom: 16}}
                           click={() => confirmMicrosoftConsent()}/>
            <BorderlessButton text="button.done-for-now"
                              size={ButtonSize.Large}
                              fullWidth={true}
                              click={() => close()}/>
          </>
        ) : (
          <PrimaryButton text="button.done-for-now"
                         size={ButtonSize.Large}
                         fullWidth={true}
                         click={() => close()}/>
        )}
      </div>
    </Dialog>
  )
}

const script = {
  "TEAM_ADMIN": {
    message: 'You need to be a Company Admin or a Team Admin to add a user.',
    action: 'add a user to this team from their account',
    access: ['Company Admin', 'Team Admin'],
  },
  "COMPANY_ADMIN": {
    message: 'You need to be a Company Admin to add another team.',
    action: 'add another team from their account',
    access: ['Company Admin'],
  },
  "CREATE_COMPANY": {
    message: 'You need to be a Company Admin to set up a company.',
    action: 'set up a company from their account',
    access: ['Company Admin'],
  },
  "MICROSOFT_CALENDAR": {
    message: 'Team Today needs your permission from Microsoft to sync your Outlook calendar. ' +
      'Click Continue to review and approve the permissions on Microsoft\'s sign-in page. ' +
      'Depending on your organisation\'s settings, this may require approval from your IT admin.',
    action: 'grant calendar permissions',
    access: [],
  }
}
